// auth.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, map, take, tap } from 'rxjs/operators';
import { AuthService } from '../auth/auth-service.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {
    
  
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {

    return this.authService.isAuthenticated$.pipe(
      filter(isAuth => isAuth !== null),
      take(1),
      tap(isAuthenticated => {
        
        if (!isAuthenticated) {
          this.router.navigate(['login']);
        }

        //// Store the attempted URL for redirecting after login
        //this.authService.redirectUrl = state.url;

        //// Navigate to the login page
       
        //return false;
      })
    );
   
  }
}

